import { FC, useMemo } from 'react';
import { DemandArea } from '../../../../lib/types/endUser';
import { useAppSelector } from '../../../../lib/store/hooks';
import styles from './../../../../components/HouseDesktop/index.module.scss';
import { HouseDesktop } from '../../../../components/HouseDesktop';
import { NewHouseModelDesktop } from '../../../endUserHouseModelNew/components/NewHouseModelDesktop';
import { useIsEviTenant } from '../../../../lib/hooks/endUserHooks/useIsEviTenant';
import { EviNewHouseModelDesktop } from '../../../../components/EviNewHouseModel/components/EviNewHouseModelDesktop';

type Props = {
  demandAreas?: DemandArea[];
  buttonColor?: string;
  buttonText?: string;
};

export const EndUserHouse: FC<Props> = ({ demandAreas, buttonColor, buttonText }) => {
  const { demandArea, tenantAndProject } = useAppSelector(({ endUser }) => endUser);

  const showButton = demandArea?.tenant.name !== 'EnergieSchwaben' && buttonText;
  const applyNewHouse =
    (tenantAndProject?.subDomain === 'energie-schwaben' &&
      tenantAndProject?.tenantId === 11002) ||
    (tenantAndProject?.domain === 'preprod.hausversorger.de' &&
      tenantAndProject?.tenantId === 11005);

  const isEviTenant = useIsEviTenant();

  const handleCategoryClick = () => {
    //
  };

  const handleKeyDown = () => {
    //
  };

  const handleAreaClick = () => {
    //
  };

  const RenderHouse = useMemo(() => {
    if (applyNewHouse) {
      return (
        <NewHouseModelDesktop
          demandAreas={demandAreas}
          buttonColor={buttonColor}
          buttonText={buttonText}
          showButton={!!showButton}
          handleCategoryClick={handleCategoryClick}
          handleKeyDown={handleKeyDown}
          handleAreaClick={handleAreaClick}
          fillAllCategories={true}
        />
      );
    } else if (isEviTenant) {
      return (
        <EviNewHouseModelDesktop
          demandAreas={demandAreas}
          buttonColor={buttonColor}
          buttonText={buttonText}
          showButton={!!showButton}
          handleCategoryClick={handleCategoryClick}
          handleKeyDown={handleKeyDown}
          handleAreaClick={handleAreaClick}
          fillAllCategories={true}
        />
      );
    } else {
      return (
        <HouseDesktop
          demandAreas={demandAreas}
          buttonColor={buttonColor}
          buttonText={buttonText}
          showButton={!!showButton}
          handleCategoryClick={handleCategoryClick}
          handleKeyDown={handleKeyDown}
          handleAreaClick={handleAreaClick}
          fillAllCategories={true}
        />
      );
    }
  }, [applyNewHouse, buttonColor, buttonText, demandAreas, isEviTenant, showButton]);

  return (
    <div style={{ width: 690 }} className={styles.mainContainer}>
      {RenderHouse}
    </div>
  );
};
